import { setNotificationMessages } from 'domains/notification/reducer';
import { NotificationMessages } from 'domains/notification/types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { genFetchedData } from 'redux/fetchedData';

export const NOTIFICATION_LS_KEY = 'notification_messages';
export const LSRemoveTime = 3 * 24 * 60 * 60 * 1000;

export const NotificationInitializer = (): null => {
  const dispatch = useDispatch();

  const parseNotificationDate = (value?: string): number | null => {
    if (!value) return null;
    const trimmed = value.trim();
    if (!/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2}$/.test(trimmed)) return null;

    const iso = trimmed.replace(' ', 'T');
    const t = Date.parse(iso);
    return Number.isNaN(t) ? null : t;
  };

  const removeDuplicates = (
    notifications: NotificationMessages,
  ): NotificationMessages => {
    const seen = new Set<number>();
    return notifications.filter((item) => {
      const id = item?.notification_id;
      if (!id) return true;
      if (seen.has(id)) return false;
      seen.add(id);
      return true;
    });
  };

  const cleanupOldNotifications = () => {
    const savedNotifications = localStorage.getItem(NOTIFICATION_LS_KEY);
    if (!savedNotifications) return;

    try {
      const parsedData: NotificationMessages = JSON.parse(savedNotifications);
      if (!Array.isArray(parsedData)) return;

      const uniqueNotifications = removeDuplicates(parsedData);
      const now = Date.now();

      const freshNotifications = uniqueNotifications.filter((item) => {
        const ts = parseNotificationDate(item?.date);
        if (!ts) return false;
        return Math.abs(now - ts) <= LSRemoveTime;
      });

      if (freshNotifications.length !== parsedData.length) {
        localStorage.setItem(
          NOTIFICATION_LS_KEY,
          JSON.stringify(freshNotifications),
        );
      }

      const fetchedData = genFetchedData(freshNotifications)
        .set('isLoading', false)
        .set('LTU', Date.now());

      dispatch(setNotificationMessages(fetchedData));
    } catch (e) {
      console.error('NotificationInitializer error', e);
    }
  };

  useEffect(() => {
    cleanupOldNotifications();

    const timerId = setInterval(cleanupOldNotifications, 1000);

    return () => {
      clearInterval(timerId);
    };
  }, [dispatch]);

  return null;
};
